<h3 mat-dialog-title>Personal</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Name</mat-label>
            <input matInput type="text" name="trailPersonalName" [(ngModel)]="trailPersonal.name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Position</mat-label>
            <textarea matInput type="text" name="position" [(ngModel)]="trailPersonal.position"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Company</mat-label>
            <textarea matInput type="text" name="company" [(ngModel)]="trailPersonal.company"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Certificate</mat-label>
            <textarea matInput type="text" name="certificate" [(ngModel)]="trailPersonal.certificate"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Remarks</mat-label>
            <textarea matInput type="text" name="remarks" [(ngModel)]="trailPersonal.remarks"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailPersonal" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>